import React, { useCallback, useEffect, useState } from "react";
import Toast from "./Toast";
import { subscribeToNotices } from "../../utils/notify";

/**
 * How long each kind stays up. A success only confirms what the person just
 * did; a refusal has to be read, and may carry a whole sentence from the API.
 */
const DURATION = {
  success: 3000,
  warning: 6000,
  error: 7000,
};

/**
 * Shows whatever `notify` (utils/notify.js) last reported. Mounted once, in
 * App.jsx, so a save that navigates away — or closes the modal it came from —
 * still gets its message seen.
 *
 * One notice at a time: a newer one replaces the current one rather than
 * stacking down the screen. `key` remounts the Toast so the
 * replacement gets its full time on screen.
 */
const SnackbarHost = () => {
  const [notice, setNotice] = useState(null);

  useEffect(() => subscribeToNotices(setNotice), []);

  const handleClose = useCallback(() => setNotice(null), []);

  if (!notice) return null;

  return (
    <Toast
      key={notice.id}
      open
      message={notice.message}
      severity={notice.severity}
      duration={DURATION[notice.severity]}
      onClose={handleClose}
    />
  );
};

export default SnackbarHost;
